// Material UI
import { Grid, Icon, Chip } from '@mui/material';

// Componentes
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { getFormikUtil } from '@utils/Utilities';

/* Afecta a:
      Celular
      Telefono
      TelMensajes
      Correo
*/

const ContactInformationForm = (props) => {
  const { formik, isLoading, disablePhone = false, disableEmail = false, showChip = true } = props;

  const getFormik = (value) => getFormikUtil(formik, 'contact', value);

  const handleCelular = ({ target: { value } }) => {
    formik.setValues({
      ...formik.values,
      contact: { ...formik.values.contact, Celular: value },
      account: { ...formik.values.account, PIN: value?.substring(0, 5) || '' },
    });
  };

  return (
    <Grid container spacing={3}>
      {showChip && (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Chip icon={<Icon>contact_phone</Icon>} label="Contacto" />
        </Grid>
      )}

      {!disablePhone && (
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <TextFieldTK
            required
            fullWidth
            label="Telefono Celular"
            name="contact.Celular"
            value={getFormik('Celular')?.value}
            onChange={handleCelular}
            disabled={isLoading}
            error={getFormik('Celular')?.error}
            helperText={getFormik('Celular')?.helperText}
            icon={{ text: '+52' }}
            isNumber
            maxLength={10}
          />
        </Grid>
      )}

      {/* <Grid item xs={12} sm={12} md={3} lg={3}>
        <TextFieldTK
          fullWidth
          label="Telefono Fijo (opcional)"
          name="contact.Telefono"
          value={getFormik('Telefono')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('Telefono')?.error}
          helperText={getFormik('Telefono')?.helperText}
          isNumber
          maxLength={10}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={3} lg={3}>
        <TextFieldTK
          fullWidth
          label="Telefono Mensajes (opcional)"
          name="contact.TelMensajes"
          value={getFormik('TelMensajes')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('TelMensajes')?.error}
          helperText={getFormik('TelMensajes')?.helperText}
          isNumber
          maxLength={10}
        />
      </Grid> */}

      {!disableEmail && (
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <TextFieldTK
            required
            fullWidth
            type="email"
            name="contact.Correo"
            label="Correo Electronico"
            placeholder="example@gmail.com"
            value={getFormik('Correo')?.value}
            onChange={formik.handleChange}
            disabled={isLoading}
            error={getFormik('Correo')?.error}
            helperText={getFormik('Correo')?.helperText}
            icon={{ icon: 'email' }}
            useTrim
            noSpaces
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ContactInformationForm;
